import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import { ButtonLink } from "../Button";
import { isVenue, token } from "../../modules/auth";
import * as VENUE_ROUTES from "../../Router/venue_routes";

const VenueReviewPackagesAlert = ({ token, isVenueUser }) => {
  const [reviewData, setReviewData] = useState();
  const [showAll, setShowAll] = useState(false);
  const location = useLocation();
  useEffect(() => {
    if (!isVenueUser) return;

    const fetchReviewData = async () => {
      try {
        const response = await axios.get(
          `${window.API}/venues/any/data/to-review`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setReviewData(response.data);
      } catch (error) {
        console.error("Error fetching review data", error);
      }
    };

    fetchReviewData();
  }, [token, isVenueUser, location.pathname]);

  if (!reviewData?.packages && !reviewData?.rooms) {
    return null;
  }

  const packageItems =
    (reviewData.packages || []).map(pkg => ({
      id: `package-${pkg.venue_package_id}`,
      type: "package",
      venue: pkg.venue,
      name: pkg.package_name,
      link: VENUE_ROUTES.FRONTEND.VENUE.EDIT.replace(
        ":venue",
        pkg.venue.slug,
      ).replace(":section", "conference-pricing"),
    })) || [];

  const roomItems =
    (reviewData.rooms || []).map(room => ({
      id: `room-${room.id}`,
      type: "room",
      venue: room.venue,
      name: room.name,
      link: VENUE_ROUTES.FRONTEND.VENUE.EDIT.replace(
        ":venue",
        room.venue.slug,
      ).replace(":section", "meeting-rooms"),
    })) || [];

  const allItems = [...packageItems, ...roomItems];
  let visibleItems;
  if (showAll) {
    visibleItems = allItems;
  } else {
    if (packageItems.length > 0 && roomItems.length > 0) {
      visibleItems = [packageItems[0], roomItems[0]];
    } else {
      visibleItems = allItems.slice(0, 2);
    }
  }

  const canToggle = allItems.length > visibleItems.length || showAll;

  return (
    <>
      <ul className="list-reset my-2">
        {visibleItems.map(item => (
          <li className="p-2 bg-blue text-white mb-1 rounded" key={item.id}>
            {item.venue.name} has had the {item.type} "{item.name}" added by an
            External Agency that you may wish to add to your profile{" "}
            <ButtonLink href={item.link} className="text-white underline">
              Click here to see more
            </ButtonLink>
          </li>
        ))}
      </ul>
      {canToggle && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="font-bold mt-2 p-2 bg-blue text-white mb-2 rounded"
        >
          {showAll
            ? "Show fewer suggestions"
            : "There are some meeting room suggestions added by agents for review – click to view"}
        </button>
      )}
    </>

  );
};

const mapStateToProps = state => {
  return {
    token: token(state),
    isVenueUser: isVenue(state),
  };
};

export default connect(mapStateToProps, {})(VenueReviewPackagesAlert);
